import React, {useEffect, useRef} from 'react';
import './ShopChestsTab.css';
import {bootTrace, isBootTraceEnabled} from '../../../../utils/debug/bootTrace';
import {SHOP_CHEST_CONFIGS} from '../../../../configs/chests';
import {CHESTS} from '../../../../constants/chests';
import ShopChestItem from '../ShopChestItem/ShopChestItem';

function ShopChestsTab({onBuyChestClick, isEternalOwned, isEternalOpened, onOpenInventory}) {
  const crystalChests = SHOP_CHEST_CONFIGS.filter((chest) => chest.priceCrystals > 0);
  const numensChests = SHOP_CHEST_CONFIGS.filter((chest) => !chest.priceCrystals && chest.priceNumens > 0);

  const contentRef = useRef(null);

  // Диагностика верстки на устройствах, куда не подлезешь инспектором
  // (?bootTrace=1): не вылезают ли карточки за высоту своей сетки. Если
  // items-bottom больше box-bottom — сетки наползают друг на друга.
  // Замер дважды: сразу и после загрузки картинок, которая может поменять
  // раскладку
  useEffect(() => {
    if (!isBootTraceEnabled()) return;

    const measure = (label) => {
      const root = contentRef.current;
      if (!root) return;
      root.querySelectorAll('.shop-chests-grid').forEach((grid, index) => {
        const gridRect = grid.getBoundingClientRect();
        const itemsBottom = [...grid.children]
          .reduce((lowest, item) => Math.max(lowest, item.getBoundingClientRect().bottom), 0);
        bootTrace(`shop grid ${index} ${label}: box ${Math.round(gridRect.top)}..${Math.round(gridRect.bottom)}`
          + ` items to ${Math.round(itemsBottom)}${itemsBottom > gridRect.bottom + 1 ? ' OVERFLOW' : ''}`);
      });
    };

    measure('start');
    const timeoutId = setTimeout(() => measure('loaded'), 2000);
    return () => clearTimeout(timeoutId);
  }, []);

  const getChestProps = (chest) => chest.id === CHESTS.ETERNAL
    ? {isOwned: isEternalOwned, isOpened: isEternalOpened, onOpenInventory}
    : {};

  return (
    <div className="shop-tab-content" ref={contentRef}>
      <div className="shop-chests-grid">
        {crystalChests.map((chest) => (
          <ShopChestItem
            key={chest.id}
            chest={chest}
            onBuy={onBuyChestClick}
            {...getChestProps(chest)}
          />
        ))}
      </div>

      {numensChests.length > 0 && (
        <div className="shop-chests-grid shop-chests-grid_numens">
          {numensChests.map((chest) => (
            <ShopChestItem
              key={chest.id}
              chest={chest}
              onBuy={onBuyChestClick}
              {...getChestProps(chest)}
            />
          ))}
        </div>
      )}
    </div>
  );
}

export default ShopChestsTab;
